var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsStackoverflow = function SvgMillustrationsStackoverflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "m30.709 22.794-6.11-1.284.257-1.222 6.11 1.285zm.358-1.573-5.659-2.636.527-1.132 5.66 2.636zm.704-1.417-4.797-3.995.799-.96 4.798 3.995zM29.07 13.6l1.002-.746 3.725 5.01-1.001.745zm1.638 10.767h-6.22v-1.244h6.22zm2.488-2.488H31.95v3.732h-8.707V21.88H22v4.976h11.195z",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsStackoverflow;